export var EventCategory;
(function (EventCategory) {
    EventCategory["BatteryLevel"] = "BATTERY_LEVEL";
    EventCategory["DFURequest"] = "DFU_REQUEST";
    EventCategory["DeviceBoot"] = "DEVICE_BOOT";
    EventCategory["DeviceConnect"] = "DEVICE_CONNECT";
    EventCategory["DeviceDisconnect"] = "DEVICE_DISCONNECT";
    EventCategory["DeviceError"] = "DEVICE_ERROR";
    EventCategory["DeviceProvision"] = "DEVICE_PROVISION";
    EventCategory["DrivingEvent"] = "DRIVING_EVT";
    EventCategory["DrivingRoute"] = "DRIVING_ROUTE";
    EventCategory["Environment"] = "ENVIRONMENT";
    EventCategory["EnvironmentThreshold"] = "ENV_THRESHOLD";
    EventCategory["GeofenceEntered"] = "GEOFENCE_ENTERED";
    EventCategory["GeofenceExited"] = "GEOFENCE_EXITED";
    EventCategory["Location"] = "LOCATION";
    EventCategory["LowBattery"] = "LOW_BATTERY";
    EventCategory["Motion"] = "IMU_MOTION";
    EventCategory["OTAPRequest"] = "OTAP_REQUEST";
    EventCategory["Shock"] = "IMU_SHOCK";
    EventCategory["SiteEntered"] = "SITE_ENTERED";
    EventCategory["SiteExited"] = "SITE_EXITED";
    EventCategory["InventoryAdded"] = "INVENTORY_ADDED";
    EventCategory["InventoryRemoved"] = "INVENTORY_REMOVED";
    EventCategory["WearableAlert"] = "WEARABLE_ALERT";
    EventCategory["CustomEvent"] = "CUSTOM_EVENT";
})(EventCategory || (EventCategory = {}));
//# sourceMappingURL=event.js.map